import React, { Component } from "react";
import AllStates from "../AllStates";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
// import Ax from "axios"

class ProjectTable extends Component {
  state = { procurementmodels: [], projecttype: [] };
  BASE_URL = "https://api.transportationprojects.org/api";
  componentDidMount = () => {
    fetch(this.BASE_URL + "/procurementmodel")
      .then(response => response.json())
      .then(procurementmodels => {
        this.setState({
          procurementmodels: procurementmodels.map(x => x.name)
        });
      });
    fetch(this.BASE_URL + "/projecttype")
      .then(response => response.json())
      .then(projecttype => {
        this.setState({
          projecttype: projecttype.map(x => x.name)
        });
      });
      localStorage.removeItem("")
  };
  render = () => {
    const DataStatusName = ["Draft", "Submitted", "Published"].reverse();
    let shownProjectItems;
    if (this.props.mode !== 0) {
      shownProjectItems = this.props.projectItems.filter(
        projectItem =>
          projectItem.data_status &&
          projectItem.data_status.name === DataStatusName[3 - this.props.mode]
      );
    } else {
      shownProjectItems = this.props.projectItems;
    }
    shownProjectItems = shownProjectItems.map(x => {
      x.state_id =
        x.state_id + " " + x.second_state_id + " " + x.third_state_id;
      return x;
    });
    const columns = [
      {
        Header: "Project ID",
        accessor: "project_id",
        width: 70,
        show: false
      },
      { Header: "Project Name", accessor: "name" },
      { Header: "Project Alias", accessor: "project_alias_name" },
      {
        Header: "State(s)",
        accessor: "state_id",
        id: "state_id",
        maxWidth: 250,
        Cell: props => {
          let res = [
            ...new Set(
              props.value
                .split(" ")
                .map(
                  v =>
                    v &&
                    AllStates[Number.parseInt(v) - 1] &&
                    AllStates[Number.parseInt(v) - 1].state_name
                )
            )
          ]
            .join(", ")
            .slice(0, -2)
            .replace(/Columb$/, "Columbia");

          return res;
        }
      },
      {
        Header: "Status",
        accessor: "data_status_id",
        show: false,
        Cell: props => DataStatusName[props.value - 1]
      },
      { Header: "Capital Cost($Mil)", accessor: "total_capital_cost" },
      {
        Header: "Project Type",
        accessor: "proj_type_id",
        show: true,
        Cell: props => this.state && this.state.projecttype[props.value - 1]
      },
      {
        Header: "Procurement Model",
        accessor: "procurement_model_id",
        show: true,
        Cell: props =>
          this.state && this.state.procurementmodels[props.value - 1]
      }
    ];
    columns.forEach(h => (h.headerStyle = { fontWeight: "bold" }));

    let filterCaseInsensitive = (filter, row) => {
      const id = filter.pivotId || filter.id;
      if (filter.id === "state_id") {
        let res = [
          ...new Set(
            row.state_id
              .split(" ")
              .map(
                v =>
                  v &&
                  AllStates[Number.parseInt(v) - 1] &&
                  AllStates[Number.parseInt(v) - 1].state_name.toLowerCase()
              )
          )
        ];
        return res.some(x => x && x.startsWith(filter.value.toLowerCase()));
      }
      if (filter.id === "proj_type_id") {
        let res = [
          ...new Set(
            row.proj_type_id
              .toString()
              .split(" ")
              .map(
                v =>
                  v &&
                  this.state.projecttype[Number.parseInt(v) - 1] &&
                  this.state.projecttype[Number.parseInt(v) - 1].toLowerCase()
              )
          )
        ];
        return res.some(x => x && x.startsWith(filter.value.toLowerCase()));
      }
      if (filter.id === "procurement_model_id") {
        let res = [
          ...new Set(
            row.procurement_model_id
              .toString()
              .split(" ")
              .map(
                v =>
                  v &&
                  this.state.procurementmodels[Number.parseInt(v) - 1] &&
                  this.state.procurementmodels[
                    Number.parseInt(v) - 1
                  ].toLowerCase()
              )
          )
        ];
        return res.some(x => x && x.startsWith(filter.value.toLowerCase()));
      }

      return row[id]
        ? String(String(row[id]).toLowerCase()).includes(
            filter.value.toLowerCase()
          )
        : false;
    };
    return (
      <div>
        <div className={"table"}>
          <div>
            {/*<button type={"button"} style={{margin: "10px"}} onClick={() => this.changeModeHandler(0)}>Show All</button>*/}
          </div>
          <ReactTable
            className="-highlight -striped my-auto"
            data={shownProjectItems}
            columns={columns}
            page={this.props.page}
            onPageChange={this.props.changePage}
            defaultFilterMethod={filterCaseInsensitive}
            filterable
            onFilteredChange={filters => {
              console.log(filters)
              localStorage.setItem("project_filters", JSON.stringify(filters))
            }}
            defaultFiltered={JSON.parse(localStorage.getItem("project_filters"))||[]}
            getTdProps={(state, rowInfo, column, instance) => {
              return {
                onClick: (e, handleOriginal) => {
                  this.props.history.push("/project/detail");
                  if (rowInfo) this.props.clicked(rowInfo.row.project_id);
                }
              };
            }}
          />
        </div>
      </div>
    );
  };
}

export default withRouter(ProjectTable);
